import { Link, NavLink } from "react-router-dom";
import SvgIcon from "../../../assets/icons/SvgIcon";
import React, { useState, useEffect, useRef } from "react";
import {
  CUSTOMER_NAVBAR_LIST,
  LOCAL_STORAGE_KEYS,
  MENULIST_SECTION_USER_ACCOUNT_OPTIONS,
  ROLES,
} from "../../../constants";
import { getLocalStorage } from "../../../utils";
import MenuDropDown from "../../MenuDropdown";
import Image from "../../Image";
import "./customer-navbar.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { logout } from "../../../redux/slices/authSlice";
import CustomerAuth from "../../Modal/Customer/Auth/CustomerAuthLayout";
import { RootState } from "../../../redux/reducers/allReducers";
import FetchImages from "../../../constants/imagePath";
import { AWS_BASE_URL } from "../../../clientConfig";
import SearchSection from "../../../pages/customer/Home/HomePageSection/SearchSection";
import Tooltip from "../../Tooltip";
import { USER_ROUTES } from "../../../constants/appRoutes";
import CustomerNotification from "../../Notification/CustomerNotification";
import { getSearchPropertyDetail } from "../../../redux/actions/customer/searchAction";

type subMenuClickType = {
  key: string;
  value: boolean;
};
const CustomerNewNavbar: React.FC = () => {
  const isAuthenticated = getLocalStorage(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  const userRole = getLocalStorage(LOCAL_STORAGE_KEYS.USER_ROLE);
  const sellerType = getLocalStorage(LOCAL_STORAGE_KEYS.SELLER_TYPE);

  const { userInfo }: any = useSelector((state: RootState) => state.user);
  const dispatch: AppDispatch = useDispatch();
  const toggleMenuRef = useRef<HTMLDivElement | null>(null);
  const subMenuRef = useRef<HTMLDivElement | null>(null);
  const [searchBox, setSearchBox] = useState(false);

  const [toggleMenu, setToggleMenu] = useState(false);
  const [subMenusList, setSubMenusList] = useState<subMenuClickType[]>([]);

  const handleSetSubMenuKeys = () => {
    const subMenuDropDownKey = CUSTOMER_NAVBAR_LIST?.filter(
      (menu) => menu?.subMenu?.length !== 0
    ).map((menu) => ({
      key: menu.label,
      value: false,
    }));
    setSubMenusList(subMenuDropDownKey);
  };

  const handleChangeSubMenuKey = (key: string) => {
    const newSubMenuClick = subMenusList.map((item: subMenuClickType) => {
      if (!key) {
        return { ...item, value: false };
      }

      return {
        ...item,
        value: item.key === key ? !item.value : false, // Toggle current, close others
      };
    });

    setSubMenusList(newSubMenuClick);
  };

  const handleToggleClick = (data: boolean) => {
    setToggleMenu(data);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      subMenuRef.current &&
      !subMenuRef.current.contains(event.target as Node)
    ) {
      const newSubMenuClick = subMenusList.map((item: subMenuClickType) => ({
        ...item,
        value: false,
      }));

      setSubMenusList(newSubMenuClick);
    }

    if (
      toggleMenuRef.current &&
      !toggleMenuRef.current.contains(event.target as Node)
    ) {
      handleToggleClick(false);
    }
  };

  const handleProfileMenusList = () => {
    const profileMenuList: any = [];

    MENULIST_SECTION_USER_ACCOUNT_OPTIONS.forEach((option) => {
      const hasAccess = option?.access?.includes(userRole);
      const isSellerWithAccess =
        userRole === ROLES.SELLER ? option?.seller?.includes(sellerType) : true;

      if (hasAccess && isSellerWithAccess)
        profileMenuList.push({
          key: option?.label,
          value: option?.label,
          url: option?.url,
        });
    });

    profileMenuList.push({
      key: "logout",
      value: "Logout",
    });

    return profileMenuList;
  };

  useEffect(() => {
    handleSetSubMenuKeys();
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toggleMenu]);

  const handleDropdownActions = (item: any) => {
    if (item?.key === "logout") {
      dispatch(logout());
    }
  };

  const accessWithAuthenticationPostProperty = (): boolean => {
    const propertyAccess = MENULIST_SECTION_USER_ACCOUNT_OPTIONS.filter(
      (item) => item.url === USER_ROUTES.YOUR_PROPERTY
    );

    const checkAccess = propertyAccess.some((option) => {
      const hasAccess = option?.access?.includes(userRole);
      const isSellerWithAccess =
        userRole === ROLES.SELLER ? option?.seller?.includes(sellerType) : true;

      return hasAccess && isSellerWithAccess;
    });

    return checkAccess;
  };

  return (
    <header className="top-0 z-[9999] fixed bg-white py-2 border-b border-b-gray-200 w-full h-[65px] text-black customer-navbar">
      <div className="flex md:flex-row justify-between items-center md:items-center px-4 md:px-6 select-none">
        <div className="flex justify-center items-center">
          <button
            type="button"
            className="lg:hidden h-full"
            onClick={() => handleToggleClick(true)}
          >
            <SvgIcon iconName="meneIcon" className="size-7 sm:size-8" />
          </button>
          <div className="hidden lg:flex">
            <MenuWithSubMenu
              subMenuClick={handleChangeSubMenuKey}
              subMenusList={subMenusList}
              menuList={CUSTOMER_NAVBAR_LIST.filter(
                (item) =>
                  item.label !== "Sell" ||
                  accessWithAuthenticationPostProperty()
              )?.filter((menu) => menu.side === "left")}
            />
          </div>
        </div>
        <div className="flex items-start">
          <Link to="/">
            <SvgIcon
              iconName="savitar-realty-logo"
              className="w-36 md:w-52 h-auto max-h-20"
            />
          </Link>
        </div>
        <div className="flex items-center gap-x-3">
          <div className="hidden lg:flex">
            <MenuWithSubMenu
              subMenuClick={handleChangeSubMenuKey}
              subMenusList={subMenusList}
              menuList={CUSTOMER_NAVBAR_LIST?.filter(
                (menu) => menu.side === "right"
              )}
            />
          </div>
          <div className="lg:hidden w-fit">
            <button
              type="button"
              className="flex justify-between items-center gap-x-8 bg-gray-200 p-1.5 md:p-2.5 rounded-full w-fit"
              onClick={() => setSearchBox(true)}
            >
              <span className="hidden sm:block">Search Property...</span>
              <SvgIcon iconName="Search" className="size-5 sm:size-6" />
            </button>
          </div>
          {isAuthenticated &&
          (userRole === ROLES.CUSTOMER || userRole === ROLES.SELLER) ? (
            <CustomerNotification />
          ) : null}
          <div>
            {isAuthenticated ? (
              <MenuDropDown
                heading={
                  <div className="flex justify-center items-center gap-2 px-2 py-1 md:rounded rounded-full outline-none">
                    <div className="min-w-10 min-h-10">
                      <Image
                        src={
                          userInfo?.profile
                            ? `${AWS_BASE_URL}${userInfo?.profile}`
                            : FetchImages.IMAGE_USER_DEFAULT
                        }
                        alt={"User Image"}
                        imgClassName="rounded-full"
                        handleOnError={(e: any) =>
                          (e.target.src = FetchImages.IMAGE_USER_DEFAULT)
                        }
                      />
                    </div>
                    <div className="hidden md:block">
                      <Tooltip message={userInfo?.full_name}>
                        <span className="block w-fit overflow-hidden font-medium text-lg text-ellipsis">
                          {userInfo?.full_name?.split(" ")[0]}
                        </span>
                      </Tooltip>
                    </div>
                  </div>
                }
                menuItems={handleProfileMenusList()}
                handleClick={handleDropdownActions}
              />
            ) : (
              <CustomerAuth
                btnName={
                  <div className="flex justify-between items-center gap-3 p-2">
                    <SvgIcon iconName="user" className="size-5 md:size-6" />
                    <span className="hidden lg:block font-semibold text-lg">
                      Login
                    </span>
                  </div>
                }
                btnClassName="w-fit p-0 rounded-full lg:rounded-md h-fit"
              />
            )}
          </div>
        </div>
      </div>
      {/* Mobile Menu bar */}
      <div
        className={`lg:hidden absolute top-0 bg-white h-dvh w-full sm:max-w-96 shadow border border-gray-200 divide-y divide-gray-300 transition-all ease-in-out duration-500 ${toggleMenu ? "left-0" : "-left-full"}`}
      >
        <div className="flex justify-between items-center px-8 py-6">
          <Link to={USER_ROUTES.ROOT}>
            <SvgIcon
              iconName="savitar-realty-logo"
              className="w-40 h-auto max-h-16"
            />
          </Link>
          <button type="button" onClick={() => handleToggleClick(false)}>
            <SvgIcon iconName="close" className="size-8" />
          </button>
        </div>
        <div
          className="h-[calc(100vh-88px)] overflow-y-auto"
          ref={toggleMenuRef}
        >
          <MenuWithSubMenu
            menuList={CUSTOMER_NAVBAR_LIST?.filter((menu: any) => {
              const hasAccess =
                menu?.access?.includes("EVERYONE") ||
                menu?.access?.includes(userRole);
              const isSellerWithAccess =
                userRole === ROLES.SELLER
                  ? menu?.access?.includes("EVERYONE") ||
                    menu?.seller?.includes(sellerType)
                  : true;

              return hasAccess && isSellerWithAccess;
            })}
            subMenusList={subMenusList}
            subMenuClick={handleChangeSubMenuKey}
            closeToggle={() => handleToggleClick(false)}
          />
        </div>
      </div>
      <div className="lg:hidden block">
        <SearchSection
          searchBox={searchBox}
          closeSearchBox={() => setSearchBox(false)}
        />
      </div>
    </header>
  );
};

export default CustomerNewNavbar;
interface MenuWithSubMenuProps {
  menuList: any[];
  subMenusList: subMenuClickType[];
  subMenuClick: (key: string) => void;
  closeToggle?: () => void;
}

const MenuWithSubMenu: React.FC<MenuWithSubMenuProps> = ({
  menuList = [],
  subMenusList,
  subMenuClick,
  closeToggle,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const modalOutSideClick = useRef<HTMLDivElement | null>(null);
  const userRole = getLocalStorage(LOCAL_STORAGE_KEYS.USER_ROLE);
  const sellerType = getLocalStorage(LOCAL_STORAGE_KEYS.SELLER_TYPE);

  const [subMenuList, setSubMenuList] = useState<{
    subMenuList: any;
    menu: any;
  }>({
    subMenuList: null,
    menu: null,
  });

  const handleClickOutside = (event: MouseEvent) => {
    if (
      modalOutSideClick.current &&
      !modalOutSideClick.current.contains(event.target as Node)
    ) {
      setTimeout(() => {
        subMenuClick(""); // Close the submenu
      }, 100);
    }
  };

  // Listen for outside clicks
  useEffect(() => {
    if (subMenusList[0]?.value) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [subMenusList]);

  return (
    <>
      <ul className="flex lg:flex-row flex-col justify-center items-start lg:items-center gap-x-4">
        {menuList?.map((menu: any, mainIndex) => (
          <li
            key={mainIndex}
            className="relative lg:first:mt-0 first:mt-8 px-6 lg:px-4 py-4 lg:py-3 w-full lg:w-fit"
          >
            {/* If the menu has a submenu */}
            {menu?.subMenu?.length !== 0 ? (
              <button
                type="button"
                onClick={() => {
                  setSubMenuList({
                    subMenuList: menu?.subMenu,
                    menu: menu,
                  });
                  subMenuClick(menu?.label);
                }}
                className="w-full hover:text-blue-500"
                onMouseEnter={() => {
                  if (!subMenusList?.[mainIndex].value) {
                    setSubMenuList({
                      subMenuList: menu?.subMenu,
                      menu: menu,
                    });
                    subMenuClick(menu?.label);
                  }
                }}
              >
                <span className="flex justify-between items-center gap-x-3">
                  {menu?.label}
                  <span
                    className={`block lg:hidden transition-all ease-in-out duration-200 ${subMenusList.find((subMenu) => subMenu.key == subMenuList.menu?.label && subMenu.value) ? "rotate-180" : "rotate-0"}`}
                  >
                    <SvgIcon iconName="arrow-down" />
                  </span>
                </span>
              </button>
            ) : (
              <NavLink
                to={menu?.url}
                onClick={() => {
                  closeToggle && closeToggle();
                }}
                className="hover:text-blue-500 navbar-links"
              >
                {menu?.label}
              </NavLink>
            )}
          </li>
        ))}
      </ul>
      {/* Submenu */}
      <div>
        {subMenuList.subMenuList ? (
          <div
            className={`${
              subMenusList.find(
                (subMenu) =>
                  subMenu.key == subMenuList.menu?.label && subMenu.value
              )
                ? "block"
                : "hidden"
            } bg-white absolute top-48 lg:top-3/4 left-5 lg:left-6 w-11/12 lg:w-screen max-w-2xl lg:shadow rounded-md px-6 py-4 border border-gray-200`}
            ref={modalOutSideClick}
          >
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {subMenuList.subMenuList?.map(
                (subMenuSection: any, subMenuSectionIndex: number) => (
                  <div key={subMenuSectionIndex}>
                    <h3 className="font-medium text-xl">
                      {subMenuSection?.section}
                    </h3>
                    <ul className="mt-3 pl-3">
                      {subMenuSection?.menuList
                        ?.filter((subMenu: any) => {
                          const hasAccess =
                            subMenu?.access?.includes("EVERYONE") ||
                            subMenu?.access?.includes(userRole);
                          const isSellerWithAccess =
                            userRole === ROLES.SELLER
                              ? subMenu?.access?.includes("EVERYONE") ||
                                subMenu?.seller?.includes(sellerType)
                              : true;

                          return hasAccess && isSellerWithAccess;
                        })
                        ?.map((subMenu: any, subMenuIndex: number) => (
                          <li key={subMenuIndex} className="py-2">
                            <Link
                              to={subMenu?.url}
                              className="hover:text-blue-500"
                              onClick={() => {
                                subMenuClick(subMenuList.menu?.label);
                                if (
                                  subMenu?.label === "Apartment" ||
                                  subMenu?.label === "Commercial"
                                ) {
                                  const data = {
                                    category_id: subMenu?.url?.split("=")[1],
                                    page: 1,
                                    limit: 50,
                                    startPrice: 0,
                                    endPrice: 0,
                                  };
                                  dispatch(getSearchPropertyDetail(data));
                                } else if (
                                  subMenu?.label === "Ready To Move" ||
                                  subMenu?.label === "Under Construction"
                                ) {
                                  const data = {
                                    status: subMenu?.url?.split("=")[1],
                                    page: 1,
                                    limit: 50,
                                    startPrice: 0,
                                    endPrice: 0,
                                  };
                                  dispatch(getSearchPropertyDetail(data));
                                }

                                closeToggle && closeToggle();
                              }}
                            >
                              <span>{subMenu?.label}</span>
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </div>
                )
              )}
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};
